export class NumberHelper {

  public static roundNumber(value: number, roundParameter = 1): number {
    if (value && Number(value)) {
      value = Math.round(value * roundParameter) / roundParameter;
      if (Number.isNaN(value)) {
        return null;
      }
    } else {
      return null;
    }
    return value;
  }

}
